import {
  UPDATE_SEARCH_QUERY,
  UPDATE_MESSAGE_FILTER,
} from '../actions/chat'

const initialState = {
  searchQuery: '',
  messageFilter: 'all',
}

const searchQuery = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.payload,
      }
    case UPDATE_MESSAGE_FILTER:
      return {
        ...state,
        messageFilter: action.payload,
      }
    default:
      return state
  }
}

export default searchQuery
